import React, { useState, useEffect } from 'react';
import { create } from 'zustand';
import { getWellnessLogsForUsers } from 'src/queries/wellnessLogs';

export const useWellnessLogs = create((set, get) => {
  // Bumped on every fetch so a slow response for a previously selected group
  // can't overwrite the logs of the group that's selected now
  let latestRequest = 0;

  return {
    logs: [],
    loadingLogs: false,
    setLogs: (newLogs) => {
      return set({ logs: newLogs });
    },
    mostRecentLogs: [],
    setMostRecentLogs: (newLogs) => {
      return set({ mostRecentLogs: newLogs });
    },
    getWellnessLogsForUsers: (appUsers) => {
      const requestId = ++latestRequest;
      set({ loadingLogs: true, logs: [], mostRecentLogs: [] });
      getWellnessLogsForUsers(appUsers, (logs) => {
        if (requestId !== latestRequest) return;
        get().getMostRecentLogsByUser(appUsers, logs);
        set({ loadingLogs: false, logs });
      });
    },
    clearLogs: () => {
      latestRequest += 1;
      set({ loadingLogs: false, logs: [], mostRecentLogs: [] });
    },
    getMostRecentLogsByUser: (appUsers, logs) => {
      const userToRecentLog = {};
      logs.forEach((log) => {
        if (
          !userToRecentLog[log.username] ||
          log.dateAndTimeToLog > userToRecentLog[log.username].dateAndTimeToLog
        ) {
          userToRecentLog[log.username] = log;
        }
      });
      const recentLogs = appUsers.map((user) => userToRecentLog[user.username] || null);
      return set({ mostRecentLogs: recentLogs });
    },
  };
});
